export type NameDescription = { name: string; description?: string | null }

export type IdNameDescription = { id: string } & NameDescription

export enum ImplicitRole {
  CASApprover = 'CAS Routing Group Approver',
  DSApprover = 'DS Discipline Approver',
  RFIResponder = 'RFI Discipline Responder',
  FDCApprover = 'FDC Approval Group Approver',
  FDCConcurrer = 'FDC Concurrence Group Concurrer',
  EJIssuer = 'EJ Issuer',
  CustomFieldEditor = 'Custom Field Editor',
}

export type ImplicitPermissions = {
  implicitRoles: ImplicitRole[]
  casRoutingGroups: NameDescription[]
  dsDisciplines: NameDescription[]
  rfiResponseDisciplines: NameDescription[]
  fdcConcurrenceGroups: NameDescription[]
  fdcApprovalGroups: NameDescription[]
  ejTypes: { name: string }[]
  customFields: Map<string, NameDescription[]>
}

export type ImplicitPermissionsUserRole = {
  id: string
  fdcApprovalGroups: IdNameDescription[]
  fdcConcurrenceGroups: IdNameDescription[]
}

export type ImplicitPermissionsUser = {
  id: string
  casRoutingGroups: NameDescription[]
  dsDisciplines: NameDescription[]
  rfiResponseDisciplines: NameDescription[]
  fdcApprovalGroups: IdNameDescription[]
  fdcConcurrenceGroups: IdNameDescription[]
  ejTypes: { name: string }[]
  roles: ImplicitPermissionsUserRole[]
}

export type ImplicitPermissionsCustomField = IdNameDescription & {
  customFieldToClassTypes: {
    classType: string
    users: {
      id: string
    }[]
    roles: {
      id: string
    }[]
  }[]
}

export type ImplicitPermissionsProps = {
  user: ImplicitPermissionsUser
  customFields: ImplicitPermissionsCustomField[] | undefined
}

export type CustomFieldEditors = NameDescription & {
  classTypes: {
    classType: string
    userIds: string[]
    roleIds: string[]
  }[]
}
